import { fabClasses } from '@mui/material';
import { NodeLabelSettings, EdgeLabelSettings } from './types';

const NODE_LABEL_SETTINGS_KEY = 'nodeLabelSettings';
const EDGE_LABEL_SETTINGS_KEY = 'edgeLabelSettings';

// Default settings
const defaultNodeLabelSettings: NodeLabelSettings = {
  showOrganizationNumber: false,
  showOrganizationName: true,
  showKonkursLikvidation: false,
  showSkuldsaldo: true,
  showAddress: true,
  showName: true,
  showFunktionarNamn: true,
  showFunktionarPersonalNumber: true,
};

const defaultEdgeLabelSettings: EdgeLabelSettings = {
  showRole: true,
  showDateRange: false,
  showDuration: false,
};

// --- Node Label Settings ---

export const loadNodeLabelSettings = (): NodeLabelSettings => {
  try {
    const storedSettings = sessionStorage.getItem(NODE_LABEL_SETTINGS_KEY);
    if (storedSettings) {
      return { ...defaultNodeLabelSettings, ...JSON.parse(storedSettings) };
    }
  } catch (error) {
    console.error('Error loading node label settings from sessionStorage:', error);
  }
  return defaultNodeLabelSettings;
};

export const saveNodeLabelSettings = (settings: NodeLabelSettings) => {
  try {
    sessionStorage.setItem(NODE_LABEL_SETTINGS_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving node label settings to sessionStorage:', error);
  }
};

// --- Edge Label Settings ---

export const loadEdgeLabelSettings = (): EdgeLabelSettings => {
  try {
    const storedSettings = sessionStorage.getItem(EDGE_LABEL_SETTINGS_KEY);
    if (storedSettings) {
      return { ...defaultEdgeLabelSettings, ...JSON.parse(storedSettings) };
    }
  } catch (error) {
    console.error('Error loading edge label settings from sessionStorage:', error);
  }
  return defaultEdgeLabelSettings;
};

export const saveEdgeLabelSettings = (settings: EdgeLabelSettings) => {
  try {
    sessionStorage.setItem(EDGE_LABEL_SETTINGS_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving edge label settings to sessionStorage:', error);
  }
};
